import { NELO_CONVERSION_ID_HEADER } from "@/platform/api/constants"
import { errorStatus } from "@/platform/api/errors"
import { buildMetaHeaders } from "@/platform/api/meta-headers"

export const body = <T>(request: PromiseLike<{ data: T }>): Promise<T> => Promise.resolve(request).then(({ data }) => data)

export const orNull = <T>(request: Promise<T>): Promise<T | null> =>
  request.catch((error: unknown) => {
    if (errorStatus(error) === 404) return null
    throw error
  })

export const bearer = (token: string): Record<string, string> => ({ Authorization: `Bearer ${token}` })

export const conversionHeaders = (conversionId?: string): Record<string, string> => ({
  ...buildMetaHeaders(),
  ...(conversionId ? { [NELO_CONVERSION_ID_HEADER]: conversionId } : {}),
})
